import { useEffect, useState } from "react";

import { PRIDE_EVENTS_2025 } from "./data";

import { shuffleArray } from "@/utils/randomize";
import { type EventOverview } from "@/schemas/events/EventOverview";
import { EventLocation } from "@/schemas/events/filter/attributes/EventLocationSet";
import { type EventFilterCriteria } from "@/schemas/events/filter/EventFilterCriteria";
import { type ScreenConfig } from "@/schemas/screen/configs";
import { ContentTabs, Screen } from "@/schemas/screen/tabs";

type EventsHook = {
  events: EventOverview[];
  isLoading: boolean;
};

function filterEvents(
  events: EventOverview[],
  criteria: EventFilterCriteria,
): EventOverview[] {
  return events.filter((event) => {
    let toInclude = true;
    // Filter by category
    if (
      criteria.category &&
      criteria.category.values &&
      criteria.category.values.length > 0
    ) {
      toInclude &&= criteria.category.values.includes(event.type);
    }

    // Filter by status
    if (
      criteria.status &&
      criteria.status.values &&
      criteria.status.values.length > 0
    ) {
      toInclude &&= criteria.status.values.includes(event.status);
    }

    // Filter by location
    if (
      criteria.location &&
      criteria.location.values &&
      criteria.location.values.length > 0
    ) {
      const countryCode = event.location.address.countryCode as EventLocation;
      toInclude &&= criteria.location.values.includes(countryCode);
    }
    return toInclude;
  });
}

export const useEvents = (screen: ScreenConfig): EventsHook => {
  const [isLoading, setIsLoading] = useState(true);
  const [events, setEvents] = useState<EventOverview[]>([]);

  useEffect(() => {
    const loadEvents = async (): Promise<void> => {
      try {
        shuffleArray(PRIDE_EVENTS_2025);
        const filteredEvents =
          screen.filters !== null
            ? filterEvents(
                PRIDE_EVENTS_2025,
                screen.filters as EventFilterCriteria,
              )
            : PRIDE_EVENTS_2025;
        setEvents(filteredEvents);
      } finally {
        setIsLoading(false);
      }
    };

    if (
      screen.screenId === Screen.CONTENT &&
      screen.activeTabId === ContentTabs.EVENTS
    ) {
      loadEvents();
    }
  }, [screen]);

  return { events, isLoading };
};
